// src/Pages/activityData.js

import {
  Palette,
  MusicNote,
  SportsSoccer,
  Science,
  LocalLibrary,
  TrendingUp,
  Group,
  Restaurant,
  Bedtime,
} from "@mui/icons-material";

export const activityCategories = [
  { id: "art", label: "Art & Creativity", color: "#FF6B6B", icon: Palette },
  { id: "music", label: "Music", color: "#4ECDC4", icon: MusicNote },
  { id: "sports", label: "Sports", color: "#FFD166", icon: SportsSoccer },
  { id: "science", label: "Science", color: "#06D6A0", icon: Science },
  { id: "practical", label: "Practical Life", color: "#7209B7", icon: LocalLibrary },
  { id: "academic", label: "Academic", color: "#4895EF", icon: TrendingUp },
  { id: "social", label: "Social Skills", color: "#F72585", icon: Group },
  { id: "meal", label: "Meal Time", color: "#FF9E00", icon: Restaurant },
  { id: "rest", label: "Rest Time", color: "#4361EE", icon: Bedtime },
];

// 🔍 Utility for category lookup
export const getCategoryById = (id) =>
  activityCategories.find((c) => c.id === id);

// 🌈 Moods used in Activity Form
export const moodOptions = [
  "Happy",
  "Energetic",
  "Focused",
  "Curious",
  "Joyful",
  "Calm",
  "Excited",
];

// 🎯 Skill tags used in Activities
export const skillsOptions = [
  "Creativity",
  "Motor Skills",
  "Teamwork",
  "Observation",
  "Communication",
  "Coordination",
  "Sportsmanship",
  "Inquiry",
  "Patience",
  "Problem Solving",
];

// --------- INITIAL ADMIN ACTIVITY DATA ----------
export const initialAdminActivities = [
  {
    id: 1,
    title: "Color Mixing Experiment",
    date: "2025-02-15",
    time: "10:30",
    category: "art",
    className: "LKG",
    teacherId: 2,
    duration: "45 mins",
    mood: "Happy",
    photos: [
      "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=400",
      "https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=400",
    ],
    skills: ["Creativity", "Color Recognition", "Motor Skills"],
    notes:
      "Children enjoyed mixing primary colors to create new colors. Excellent participation.",
    likes: 22,
    views: 144,
  },
  {
    id: 2,
    title: "Outdoor Soccer Practice",
    date: "2025-02-14",
    time: "14:00",
    category: "sports",
    className: "UKG",
    teacherId: 3,
    duration: "1 hour",
    mood: "Energetic",
    photos: [
      "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=400",
    ],
    skills: ["Teamwork", "Strength", "Coordination"],
    notes: "Students actively participated and improved coordination.",
    likes: 31,
    views: 199,
  },
  {
    id: 3,
    title: "Plant Growth Observation",
    date: "2025-02-13",
    time: "11:00",
    category: "science",
    className: "Grade 1",
    teacherId: 2,
    duration: "50 mins",
    mood: "Curious",
    photos: [
      "https://images.unsplash.com/photo-1417733403748-83bbc7c05140?w=400",
    ],
    skills: ["Observation", "Inquiry", "Patience"],
    notes: "Children recorded changes in plant height over a week.",
    likes: 18,
    views: 140,
  },
];
